(() => {
  const dialog = document.getElementById("funnel-cart");
  if (!dialog) return;
  const SECTION = dialog.dataset.section;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const wrapper = () => document.getElementById(`shopify-section-${SECTION}`);

  const render = (html) => {
    const current = wrapper();
    if (html && current) {
      const fresh = new DOMParser().parseFromString(html, "text/html").getElementById(`shopify-section-${SECTION}`);
      if (fresh) current.innerHTML = fresh.innerHTML;
    }
    const value = current && current.querySelector("[data-cart-count-value]");
    const count = value ? value.dataset.cartCountValue : "0";
    document.querySelectorAll("[data-cart-count]").forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === "0";
    });
  };

  const open = () => {
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add("fcd-lock");
  };
  const close = () => {
    if (dialog.open) dialog.close();
  };
  dialog.addEventListener("close", () => document.documentElement.classList.remove("fcd-lock"));

  const refresh = async () => {
    const response = await fetch(`${root}?sections=${SECTION}`, { headers: { Accept: "application/json" } });
    const data = await response.json();
    render(data[SECTION]);
  };

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-cart-open]")) {
      event.preventDefault();
      open();
      refresh().catch(() => {});
      return;
    }
    if (event.target.closest("[data-cart-close]") || event.target === dialog) close();
  });

  dialog.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-line]");
    if (!button) return;
    button.setAttribute("aria-busy", "true");
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: Number(button.dataset.line), quantity: Number(button.dataset.qty), sections: [SECTION] }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || "The cart couldn't be updated.");
      render(data.sections && data.sections[SECTION]);
      document.dispatchEvent(new CustomEvent("rena:changed"));  // rena.js keeps the free gifts in step
    } catch (problem) {
      console.warn(problem);
    } finally {
      button.removeAttribute("aria-busy");
    }
  });

  // The offer adds to the cart itself and hands the rendered drawer over here.
  document.addEventListener("funnel:cart", (event) => {
    const data = event.detail || {};
    render(data.sections && data.sections[SECTION]);
    open();
  });

  window.FunnelCart = { section: SECTION, open, refresh, render };  // rena.js renders the drawer from its own cart responses
  render();
  addEventListener("pageshow", (event) => {
    if (event.persisted) refresh().catch(() => {});
  });
})();
